import React from 'react'
import { Skeleton } from 'antd'

import ProfileNotAvailable from 'components/ProfileNotAvailable/ProfileNotAvailable'
import SubscribeToChangesForm from 'components/SubscribeToChangesForm/SubscribeToChangesForm'

import BookButton from '../BookButton/BookButton'
import { BookCTAsProps } from '../type'

const BookCTAs: React.FC<BookCTAsProps> = ({
  products,
  profile,
  onButtonClick,
  profileOffline = false,
  loading = false,
  discountBadgeColor,
}) => {
  if (loading && !products.b2c?.length) {
    return <Skeleton.Button active size="large" style={{ width: '100%' }} />
  }

  if (!products.b2c?.length || profileOffline) {
    return (
      <>
        <ProfileNotAvailable profileName={profile?.name} align="left" />
        <SubscribeToChangesForm profile={profile} darkTextColor />
      </>
    )
  }

  return (
    <BookButton
      onClick={() => onButtonClick({ selectB2b: false })}
      products={products}
      profileSlug={profile.slug}
      defaultProfileProduct={profile.defaultProfileProduct}
      loading={loading}
      discountBadgeColor={discountBadgeColor}
    />
  )
}

export default BookCTAs
